module.exports = __webpack_public_path__ + "static/img/personal-info-secure.7521042.png";


//////////////////
// WEBPACK FOOTER
// ./static/appicons/personal-info-secure.png
// module id = 1143
// module chunks = 0